import { type Key, createContext } from "react";

import type { ImmutableMap } from "~/tools/immutable-map";
import type { ImmutableSet } from "~/tools/immutable-set";
import type { Impulse, ReadonlyImpulse } from "~/tools/impulse";
import { useRequiredContext } from "~/tools/use-required-context";

import type { TableOverflowState } from "./_overflow-state";
import type { TableColOrder } from "./col-order";

export interface TableContextValue {
	sortedBy: Impulse<ImmutableSet<TableColOrder>>;
	virtualRowsState: Impulse<ImmutableMap<Key, unknown>>;
	overflowState: ReadonlyImpulse<undefined | TableOverflowState>;
	scrollElement: null | HTMLElement;
}

const TableContext = createContext<null | TableContextValue>(null);

export const TableContextProvider = TableContext.Provider;

export const useTableContext = (): TableContextValue =>
	useRequiredContext(TableContext, {
		providerName: "TableContextProvider",
	});

export const VirtualRowContext = createContext<null | Key>(null);
